import axios from 'axios';
import Instruction from '@/common/instruction/components/InstructionView';
import Loader from '../modules/loader/components/Loader';
import forIn from 'lodash/forIn';
import forEach from 'lodash/forEach';
import forEachRight from 'lodash/forEachRight';
import cloneDeep from 'lodash/cloneDeep';
import findIndex from 'lodash/findIndex';
import map from 'lodash/map';
import drop from 'lodash/drop';
import dropRight from 'lodash/dropRight';
import keys from 'lodash/keys';
import values from 'lodash/values';
import moment from 'moment';
import {mapGetters, mapActions, mapState} from 'vuex';
import {TRANSFER_CONDITION, DATAPICKER} from '../modules/protocols/constants.js';
import Constants from '../modules/undesirableBehavior/Constants';
import UuidGenerator from '@/common/uuid/UuidGenerator';
import filters from '../filters/filters';
import filter from 'lodash/filter';
import lang from '../lang/translator';
import trim from 'lodash/trim';
import maxBy from 'lodash/maxBy';
import orderBy from 'lodash/orderBy';
import fill from 'lodash/fill';
import toInteger from 'lodash/toInteger';
import concat from 'lodash/concat';
import VueTimepicker from 'vue2-timepicker'

export const loadDTTData = {
  props: ['protocolId', 'phaseId', 'client', 'stageId', 'stage'],
  data() {
    return {
      apiUrl: '/protocols/assigned/dtt/',
      apiCheckedUrl: '/protocols/assigned/',
      disabled: false,
      isLoaded: false,
      protocols: null,
      protocolsData: null,
      phaseSettings: [],
      activeStep: [],
      execution: '',
      stimulus: [],
      stimulList: [],
      attempts: {},
      currentSesssionDate: null,
      startSesssionDate: null,
      uiid: null,
      stimulusListEmpty: false,
      phases: null,
      lastSession: [],
      disabledSave: true,
      rangeDateStart: null, //new Date(),
      rangeTimeStart: {
        HH: "",
        mm: ""
      },
      timerId: null,
      showDatapicker: false,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY'],
      },
      addStimulusItem: null,
      lastPhase: null,
      totalAtemptsCount: 0,
      maxTotalAtemptsCountError: false,
      maxTotalAtemptsCount: 3000,
      hourRange: [0, 23],
      minuteRange: [0, 60],
      maxDateStart: this.getMaxDateStart(new Date()),
      showChangeDateSession: false,
      duration: null,
      stageInfo: this.stage,
      newTasks: [],
    };
  },
  components: {
    Instruction,
    Loader,
    VueTimepicker
  },
  computed: {
    ...mapGetters('mobile', [
      'isMobile',
    ]),
    ...mapGetters('auth', [
      'isPreviousDateSession',
      'previousDate',
      'previousTime',
      'previousDuration'
    ]),

    ...mapState('protocol', [
      'protocolVuexData',
    ]),
    rangeDateStartTimestamp() {
      return moment(this.previousDate).unix()
    },
    rangeDateEndTimestamp() {
      return moment(this.previousDate).unix() + 3600
    },
    minDate() {
      return this.protocolsData && this.protocolsData.endDate ? moment(this.protocolsData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
    },
    conditionTransfer() {
      let condition = this.activeStep.transferCondition;

      if (condition) {
        if (condition.id == TRANSFER_CONDITION.ONE_TRIAL){
          return lang.get('protocol.one_trial');
        } else if (condition.id == TRANSFER_CONDITION.TRIAL_IN_A_ROW){
          return condition.trialCount + " " + lang.get('protocol.trial_in_row');
        } else if (condition.id == TRANSFER_CONDITION.SESSION_IN_A_ROW) {
          return condition.sessionCount + " " + lang.get('protocol.task_in_row');
        } else{
          return condition.ratio + " " + lang.get('protocol.condition_procent') + " " +
              condition.sessionCount + " " + lang.get('protocol.condition_trial') + " " +
              condition.trialCount + " " + lang.get('protocol.condition_session');
        }
      }
    },

    showDatePrevious() {
      if (this.protocolsData && this.protocolsData.endDate && this.previousDate && this.isPreviousDateSession && this.previousTime && this.previousTime.HH && this.previousTime.mm){

        let protocolDate = moment(this.minDate).unix();
        let sessionDate = new Date(this.previousDate.getFullYear(),
            this.previousDate.getMonth(),
            this.previousDate.getDate(),
            this.previousTime.HH,
            this.previousTime.mm);

        let previous = moment(sessionDate).unix();
        return previous <= protocolDate;

      }

      return false;
    },

  },
  async mounted() {
    try{
      this.currentSesssionDate = Math.round((new Date()).getTime() / 1000);
      this.startSesssionDate = new Date();
      if(!this.stage){
        let response = await axios.get(this.apiUrl + this.protocolId + '/show-stage/' + this.stageId);
        this.stageInfo = response.data.data;
      }


      await this.initProtocols();
      this.uiid = UuidGenerator.v4();
      let entity = {
        id: this.uiid,
        type: 'assigned-session',
      };

      this.showDatapicker = DATAPICKER;

      this.setEntity(entity);
    } catch (error) {
      console.dir(error);
      if (error.status == 403) {
        this.$router.push({name: 'client'});
      } else {
        this.$router.push({name: 'error'});
      }
    }


  },
  methods: {
    ...mapActions('appeals', [
      'setEntity',
    ]),

    ...mapActions('protocol', [
      'setProtocol',
      'setProtocolVersion',
    ]),

    visibleList(list) {
      let emptyList = true
      if (list){
        emptyList = filter(list, item => {return !item.moveForward}).length;
      }
      return emptyList;
    },

    changeNumber(event){
      if (!((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 46 || event.keyCode == 8|| (event.keyCode >= 35 && event.keyCode <= 40) )) {
        event.preventDefault();
      }
    },


    getMaxDateStart: function(date) {
      let clientTimeZoneOffset = this.client.timezone ? moment().tz(this.client.timezone)._offset : 0;
      let dateTime = moment(date, 'YYYY-MM-DD HH:mm').toDate();
      let dateWithTimezone = moment(dateTime.getTime() +
          (Math.abs(clientTimeZoneOffset) *
              Constants.SECONDS_PER_MINUTE * 1000)).toDate();

      return dateWithTimezone;
    },

    toLocaleDateTimeTimezone(date) {
      let dateTime = moment(date, 'YYYY-MM-DD HH:mm').toDate();
      let dateWithTimezone = dateTime.getTime() +
          (Math.abs(dateTime.getTimezoneOffset()) *
              Constants.SECONDS_PER_MINUTE * 1000);

      return moment(dateWithTimezone).format('DD.MM.YYYY HH:mm');
    },

    addStimulus: async function(item) {
      let unique = true;

      let result = await this.$validator.validate();

      if (!result) {
        return;
      }

      if (item) {

        let stimulList = this.activeStep.globalTasks;

        forIn(stimulList, function(stimul) {
          if (trim(stimul.description.toLowerCase()) ===
              trim(item.toLowerCase())) {
            unique = false;
          }
        });

        if (unique) {

          let uuid = UuidGenerator.v4();

          this.phases[0].items.push({
            attempt: 0,
            sessionAnswers: {},
            fieldIndex: this.activeStep.minFieldCount,
            taskId: null,
            description: item,
            title: item,
            answer: null,
            active: true,
            checked: true,
            type: this.activeStep.taskType,
            position: 0,
            toNextLevel: false,
            lastAnswers: [],
            attepmtsCount: '1',
            lastAnswersCount: [],
            himselfList: [],
            globalUuid: uuid,
            fieldAnswers: [{
              day: this.isPreviousDateSession ? moment(this.previousDate).format('YYYY-MM-DD') : this.today(),
              answers: [],
              himself: this.activeStep.transferCondition.id !== TRANSFER_CONDITION.RATIO ?  [] : 0,
              total: 0
            }]
          });

          this.activeStep.globalTasks.push({
            description: item,
            uuid: uuid
          });

          this.newTasks.push({
            globalUuid: uuid,
            description: item,
          });

          this.addStimulusItem = null;
          this.errors.clear();
          this.disabledSave=false;

        } else {
          this.errors.add({
            field: 'addStimulusItem',
            msg: lang.get('rotation.unique_stimulus'),
          });
        }

      } else {
        this.errors.add({
          field: 'addStimulusItem',
          msg: lang.get('protocol.stimulus_required'),
        });
      }

    },

    async checkSessionVersion() {

      let sessionVersion = axios.get(this.apiCheckedUrl + this.protocolsData.id + '/is-version-equal/' + this.activeStep.majorVersion);

      return sessionVersion;

    },

    cancelSession(){
      this.isModalVisible = false;
    },

    async saveSession(){

        let stimulus = [];
        this.isLoaded = false;
        forEach(this.phases, phase => {
          forEach(phase.items, item => {
            let attemptAnswers = [];

            forEach(item.sessionAnswers, (fieldRezult, key) => {
              attemptAnswers.push({
                field: key,
                attemptAnswers: fieldRezult,
              });
            });

            stimulus.push({
              globalUuid: item.globalUuid,
              answers: attemptAnswers,
              currentField: item.fieldIndex,
              moveForward: item.moveForward,
              description: item.description,
              attempt: item.attempt,
            });
          });
        });

        let sessionDate = null;
        let timeSessionDate = null;
        let timeSessionEndDate = null;

        if (this.isPreviousDateSession && this.previousTime.HH) {
          let clientTimeZoneOffset = this.client.timezone ? moment().tz(this.client.timezone)._offset : 0;
          sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(),
              this.previousDate.getMonth(),
              this.previousDate.getDate(),
              this.previousTime.HH,
              this.previousTime.mm));
          timeSessionDate = moment(sessionDate).unix() -
              (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE);
          timeSessionEndDate = moment(sessionDate).unix() -
              (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE) +
              this.previousDuration * Constants.SECONDS_PER_MINUTE;
        }

        let isSaved;
        isSaved = axios.post(this.apiUrl + this.protocolsData.id + '/sessions',
            {
              'assignedSessions': [
                {
                  'uuid': this.uiid,
                  //'dayUuid': this.uiid,
                  'startedAt': this.isPreviousDateSession ?
                      timeSessionDate :
                      (this.currentSesssionDate ?
                          this.currentSesssionDate :
                          Math.round((new Date()).getTime() / 1000)), //
                  'finishedAt': this.isPreviousDateSession ?
                      timeSessionEndDate :
                      Math.round((new Date()).getTime() / 1000), //
                  'stimuli': stimulus,
                  'phaseId': this.activeStep.id,
                  'type': this.activeStep.taskType
                },
              ],
              'index': this.activeStep.position,
              'majorVersion': this.activeStep.majorVersion,
              'uuid': this.activeStep.stageUuid,
              'newTasks': this.newTasks
            }).then(response => {
              this.setProtocol(null);
              /*this.isLoaded = true;
              this.initProtocols();
              this.uiid = UuidGenerator.v4();
              let entity = {
                id: this.uiid,
                type: 'assigned-session',
              };
              this.setEntity(entity);*/
              this.$router.push({name: 'choose-stage', params: {protocolsData: null, client: this.client}});

            }).catch(error => {
              this.isLoaded = true;

            });

    },

    async saveStage() {

      this.disabledSave = true;

      let checkVersion = await this.checkSessionVersion();
      if (checkVersion.data.data.result){
        this.saveSession();
      } else{
        this.isModalVisible = true;
      }

    },

    emptyLength(length){
      return 5-length > 0 ? 5-length : 0;
    },

    attemptChange: function(answer, stimul,indexPhase, title, answerCount) {
      if (this.timerId){
        clearTimeout(this.timerId);
      }
      let answerListCount = answerCount ? toInteger(answerCount) : 1;
      let answerList = fill(new Array(answerListCount), title);
      let answerListId = fill(new Array(answerListCount), answer);

      this.totalAtemptsCount = this.totalAtemptsCount + answerListCount;

      if (this.totalAtemptsCount <=3000){

        this.maxTotalAtemptsCountError = false;

        let positive = filter(this.activeStep.taskType.answers, function(item) { return item.himself; });
        let positiveAnswer = positive[0].id;


        let answerListHimself = [];


        let lastDate = stimul.fieldAnswers[0] ? stimul.fieldAnswers[0].day : this.isPreviousDateSession ? moment(this.previousDate).format('YYYY-MM-DD') : this.today();
        let lastDay = this.isPreviousDateSession ? moment(this.previousDate).format('YYYY-MM-DD') : this.today();

        let newStimuli = stimul.sessionAnswers[stimul.fieldIndex] ?
            stimul.sessionAnswers[stimul.fieldIndex] :
            [];

        newStimuli = concat(newStimuli, answerListId);
        stimul.sessionAnswers[stimul.fieldIndex] = newStimuli;

        stimul.lastAnswers = concat(stimul.lastAnswers, answerList);
        stimul.lastAnswersId = concat(stimul.lastAnswersId, answerListId);
        stimul.newSessionAnswers = concat(stimul.newSessionAnswers, answerList);


        let listHimselfAnswers = filter(stimul.fieldAnswers, item => {
          return item.day == lastDay;
        });


        if(this.activeStep.transferCondition.id !== TRANSFER_CONDITION.RATIO) {
          answerListHimself = fill(new Array(answerListCount), answer == positiveAnswer);

          if(listHimselfAnswers.length){
            if(!listHimselfAnswers.isMastered){
              listHimselfAnswers[0].himself = concat(listHimselfAnswers[0].himself, answerListHimself)
              listHimselfAnswers[0].answers = listHimselfAnswers[0].answers && listHimselfAnswers[0].answers.length ?  concat(listHimselfAnswers[0].answers, answerList) : answerList
            }
          } else{

            listHimselfAnswers = {
              day : lastDay,
              himself: answerListHimself,
              answers: answerList
            };
            stimul.fieldAnswers.unshift(listHimselfAnswers)

          }
        } else{

          answerListHimself = answer == positiveAnswer ? fill(new Array(answerListCount), answer == positiveAnswer) : [];

          if(listHimselfAnswers.length){
            if(!listHimselfAnswers.isMastered){
              listHimselfAnswers[0].himself += +answerListHimself.length
              listHimselfAnswers[0].answers = listHimselfAnswers[0].answers && listHimselfAnswers[0].answers.length ? concat(listHimselfAnswers[0].answers, answerList) : answerList;
              listHimselfAnswers[0].total += +answerListCount
            }
          } else{
            listHimselfAnswers = {
              day : lastDay,
              himself: +answerListHimself.length,
              answers: answerList,
              total: +answerListCount
            };
            stimul.fieldAnswers.unshift(listHimselfAnswers)

          }
        }


        stimul.lastAnswersCount.push(answerListCount);

        let toNextLevel = stimul.toNextLevel;
        stimul.attempt = stimul.attempt + answerListCount;
        stimul.toNextLevel = this.nextLevel(stimul);

        if (!toNextLevel && stimul.toNextLevel){
          this.phases[indexPhase].countToNextLevel++;
        }

        if (toNextLevel && !stimul.toNextLevel){
          this.phases[indexPhase].countToNextLevel--;
        }

      }

      if (this.totalAtemptsCount > this.maxTotalAtemptsCount) {
        this.maxTotalAtemptsCountError = true;
        this.totalAtemptsCount = this.totalAtemptsCount - answerListCount;
        setTimeout(() => {
          this.$refs.maxTotalAtemptsCountError.scrollIntoView();
        }, 100);

      }
      this.disabledSave = false;

      this.timerId = setTimeout(function() {
        stimul.answer = null;
        stimul.attepmtsCount = '1';
      }, 200);

    },

    backToPreviousAttempt: function(id, index, stimul, toNext) {
      let activePhase = this.phases[index].items;
      let lastDay = this.isPreviousDateSession ? moment(this.previousDate).format('YYYY-MM-DD') : this.today();
      let positive = filter(this.activeStep.taskType.answers, function(item) { return item.himself; });
      let positiveAnswer = positive[0].id;
      let lastAnswersCount = stimul.lastAnswersCount[stimul.lastAnswersCount.length - 1];

      forIn(activePhase, (item, key) => {
        let isCurrentStimulus = stimul.id ? item.id == stimul.id : item.description == stimul.description;
        if (isCurrentStimulus) {
          item.attempt = item.attempt-lastAnswersCount;
          if (this.activeStep.transferCondition.id == 'ratio'){
            item.fieldAnswers[0].total = item.fieldAnswers[0].total-lastAnswersCount;
            if (item.sessionAnswers[item.fieldIndex][item.sessionAnswers[item.fieldIndex].length - 1] == positiveAnswer){
              item.fieldAnswers[0].himself = item.fieldAnswers[0].himself-lastAnswersCount;
              item.positiveAnswersCount -= lastAnswersCount;
            }
            if (!item.fieldAnswers[0].total){
              item.fieldAnswers.shift();
            }
          } else{

            let listHimselfAnswers = filter(item.fieldAnswers, himselfItem => {
              return himselfItem.day == lastDay;
            });

            if (listHimselfAnswers.length){
              listHimselfAnswers[0].himself = dropRight(listHimselfAnswers[0].himself, lastAnswersCount);
              listHimselfAnswers[0].answers = dropRight(listHimselfAnswers[0].answers, lastAnswersCount);
            }

            if(!listHimselfAnswers[0].answers.length){
              item.fieldAnswers.shift();
            }

          }

          item.sessionAnswers[item.fieldIndex] = dropRight(item.sessionAnswers[item.fieldIndex], lastAnswersCount);
          item.toNextLevel = this.nextLevel(item);
          item.lastAnswers = dropRight(item.lastAnswers, lastAnswersCount);
          item.lastAnswersId = dropRight(item.lastAnswersId, lastAnswersCount);
          item.newSessionAnswers = dropRight(item.newSessionAnswers, lastAnswersCount);

          item.lastAnswersCount.pop();

          if (toNext && !item.toNextLevel){
            this.phases[index].countToNextLevel--;
          }
          if (!toNext && item.toNextLevel){
            this.phases[index].countToNextLevel++;
          }
          this.totalAtemptsCount = this.totalAtemptsCount - lastAnswersCount;

          if(!activePhase.length){
            this.disabledSave = true;
          }

          this.$set(activePhase,key, item);
        }
      });
    },

    goToNextLevel: function(id, stimul, indexPhase, moveForward = false) {
      let items = this.phases[indexPhase].items;
      let index = findIndex(items, function(answer) {
        if (id){
          return stimul.id == answer.id;
        } else{
          return stimul.description == answer.description;
        }
      });
      if (!moveForward){
        items.splice(index, 1);
      }

      stimul.toNextLevel = false;
      stimul.lastAnswers = [];
      stimul.lastAnswersId = [];
      stimul.newSessionAnswers = [];
      this.phases[indexPhase].countToNextLevel--;
      if (!moveForward) {
        this.phases[indexPhase + 1].items.push(stimul);
        this.phases[indexPhase + 1].items[this.phases[indexPhase + 1].items.length - 1].fieldAnswers = [{
          day : this.isPreviousDateSession ? moment(this.previousDate).format('YYYY-MM-DD') : this.today(),
          himself: this.activeStep.transferCondition.id == 'ratio' ? 0 : [],
          answers: [],
          total: 0
        }]
      }
      if (stimul.fieldIndex < this.activeStep.maxFieldCount){
        stimul.fieldIndex++
      }
      stimul.attempt = 0;
      stimul.attepmtsCount = '1';
      stimul.lastAnswersCount = [];
      stimul.moveForward = moveForward;
      this.disabledSave = false;

      if (!moveForward) {
        this.phases[indexPhase + 1].visible = true;
      } else{
        stimul.moveToNextPhase = true;
        this.$set(this.phases[indexPhase].items,index, stimul);
      }
    },

    today() {
      let dateTime = new Date();
      let dateWithTimezone = null;
      if (this.client.timezone) {
        dateWithTimezone = moment().
            tz(this.client.timezone).
            add(-(moment().utcOffset()), 'm')._d;
      } else{
        dateWithTimezone = dateTime.getTime() +
            (Math.abs(dateTime.getTimezoneOffset()) *
                Constants.SECONDS_PER_MINUTE * 1000);
      }

      return moment(dateWithTimezone).format('YYYY-MM-DD');
    },

    initProtocols: async function() {
      this.isLoaded = false;
      await this.getProtocols();
      //this.isLoaded = true;
    },

    nextLevel: function(item) {
      let condition = this.activeStep.transferCondition.id;
      let toNextLevel = false;

      let fieldAnswers = item.fieldAnswers ? filter(item.fieldAnswers, answ =>{
        return (answ.answers && answ.answers.length) || answ.total || answ.isMastered;
      }) : null;
      if (condition == TRANSFER_CONDITION.ONE_TRIAL) {

          let lastAnswers = fieldAnswers && fieldAnswers[0] ? fieldAnswers[0] : [];

          if(lastAnswers && lastAnswers.isMastered){
            toNextLevel = true;
          } else{
            toNextLevel = lastAnswers.himself && lastAnswers.himself.length ? lastAnswers.himself[0] : false;
          }


      } else if (condition == TRANSFER_CONDITION.TRIAL_IN_A_ROW) {
        let lastAnswers = fieldAnswers && fieldAnswers[0] ? fieldAnswers[0] : [];
        let trialCount = this.activeStep.transferCondition.trialCount;
        let summ = 0;

        if(lastAnswers && lastAnswers.isMastered){
          toNextLevel = true;
        } else {
          if (lastAnswers && lastAnswers.himself && lastAnswers.himself.length >= trialCount) {

            for (let i = 0; i < trialCount; i++) {
              if (lastAnswers.himself[i]) {
                summ++;
              }
            }
            toNextLevel = (summ == trialCount);
          }
        }

      } else if (condition == TRANSFER_CONDITION.SESSION_IN_A_ROW) {
        let lastSessions = [];
        let dropCount = 0;

        if (fieldAnswers){
          dropCount = (fieldAnswers.length - this.activeStep.transferCondition.sessionCount > 0) ? (fieldAnswers.length - this.activeStep.transferCondition.sessionCount) : 0
        }

        let lastAnswers = dropRight(fieldAnswers, dropCount);

        toNextLevel = false;

        if(lastAnswers && lastAnswers.length){

          forEach(lastAnswers, (answerList) => {
            if(answerList.himself && !answerList.isMastered){
              lastSessions.push(answerList.himself[0]);
            }
            if(answerList.isMastered){
              lastSessions.push(answerList.isMastered);
            }
          });


          let positiveArray = filter(lastSessions, function(o) { return o; });

          toNextLevel = (positiveArray.length >=
              this.activeStep.transferCondition.sessionCount);

        } else{
          toNextLevel = false;
        }

      } else {
        let summLevel = [];
        let countSession = 0;
        let summTrial = 0;
        let countTrial = 0;
        let trialCount = this.activeStep.transferCondition.trialCount;
        let sessionCount = this.activeStep.transferCondition.sessionCount;

        if(fieldAnswers && fieldAnswers.length >= sessionCount){

          forEach(fieldAnswers, (answerList) => {
            summTrial = 0;
            countSession++;

              countTrial = answerList.total;
              summTrial = answerList.himself;

              let trial = false;
              if (countTrial >= trialCount){
                trial = (summTrial * 100 / countTrial) >= this.activeStep.transferCondition.ratio;
              }

              if(answerList.isMastered){
                trial = true
              }

              summLevel.push(trial);

          });


        } else {
          return false;
        }
        if (countSession >= sessionCount) {

          let next = true;
          let dropCount = 0;

          if (summLevel){
            dropCount = (summLevel.length - sessionCount > 0) ? (summLevel.length - sessionCount) : 0
          }

          let lastAnswers = dropRight(summLevel, dropCount);

          forEach(lastAnswers, (answer) => {
            if (!answer){
              next = false;
            }
          });

          toNextLevel = next;
        } else {
          return false;
        }

      }

      return toNextLevel;

    },

    lastAnswerTitle: function(answer) {

      let title = filter(this.activeStep.taskType.answers, type  => {
        return type.id == answer;
      });

      return title[0] ? title[0].title : answer;

    },

    getProtocols: async function() {
      try {

        let params = {};

        if(this.isPreviousDateSession && this.previousDate) {
          let newDate = moment(this.previousDate).format('YYYY-MM-DD');
          let newDateUnix = moment.utc(newDate, 'YYYY-MM-DD').unix();

          params = {
            date: newDateUnix
          };

        }

        let response = await axios.get(this.apiUrl + this.protocolId + '/stage/' + this.stageId + '/phase/' + this.phaseId, {
          params: params,
        });
        this.protocolsData = cloneDeep(this.protocolVuexData);
        this.protocols = this.protocolsData.protocol;

        if (this.protocolsData.status.id == 4){
          this.$router.push({name: 'client-edit', params: { clientId: this.client.id }});
        }

        this.activeStep =  response.data.data;
        this.stimulList = cloneDeep(this.activeStep.stimuli);
        this.stimulList = orderBy(this.stimulList, 'position');
        this.execution = this.protocols.execution || '';


        forIn(this.stimulList, (item) => {

          item.fieldIndex = item.fieldIndex ?
              item.fieldIndex : this.activeStep.minFieldCount;
          if (item.fieldIndex < this.activeStep.minFieldCount && this.activeStep.withFields ){
            item.fieldIndex = this.activeStep.minFieldCount
          }
          item.sessionAnswers = {};
          item.attempt = 0;
          item.attepmtsCount = '1';
          item.lastAnswersCount = [];
          item.lastAnswersId = [];
          item.type = this.activeStep.taskType;
          item.moveForward = false;
          item.newSessionAnswers = [];
          item.toNextLevel = this.nextLevel(item);

        });

        let phases = [];

        if (this.activeStep.withFields) {

          for (let i = 0; i <= (this.activeStep.maxFieldCount -
              this.activeStep.minFieldCount); i++) {
            let listToNextLevel = filter(this.stimulList, (item) => {
              return item.fieldIndex == i + +this.activeStep.minFieldCount && item.toNextLevel;
            });
            phases[i] = {
              visible: i ? false : true,
              countToNextLevel: listToNextLevel ? listToNextLevel.length : 0,
              items: filter(this.stimulList, (item) => {
                return (item.fieldIndex == i + +this.activeStep.minFieldCount)
              }),
            };
          }
        } else {
          phases[0] = {
            visible: true,
            countToNextLevel: 0,
            items: this.stimulList
          };
        }
        this.phases = phases;

        this.isLoaded = true;
      } catch (error) {
        console.dir(error);
        //this.$router.push({name: 'client-edit', params: { clientId: this.client.id }});
      } finally {

      }
    },

  },
  watch: {
    previousDate(newValue, oldValue){

      let oldDay = oldValue ? moment(oldValue).format('YYYY-MM-DD') : this.today();
      let newDay = moment(newValue).format('YYYY-MM-DD');

      forEach(this.stimulList, item => {

        let lastAnswersCount = item.attempt;
        let answIndex = findIndex(this.activeStep.stimuli, field => field.globalUuid === item.globalUuid);

          let fieldAnswIndex = findIndex(item.fieldAnswers, field => field.day === oldDay);
          let fieldAnswIndexNew = findIndex(item.fieldAnswers, field => field.day === newDay);
          let fieldAnswIndexBefore = findIndex(this.activeStep.stimuli[answIndex].fieldAnswers, field => field.day === oldDay);
          let answers = item.newSessionAnswers;

          let positive = filter(this.activeStep.taskType.answers, function(item) { return item.himself; });
          let positiveAnswer = positive[0].title;
          let positiveAnswersCount = filter(answers, answ => answ ==positiveAnswer).length;
          let answersArray = map(answers, answ => {
            return answ ==positiveAnswer;
          });

          let beforeItem = this.activeStep.stimuli[answIndex].fieldAnswers[fieldAnswIndexBefore];


          if(fieldAnswIndex >= 0){

            if(oldDay ==  moment(this.minDate).format('YYYY-MM-DD')) {

              item.fieldAnswers.unshift({
                day: newDay,
                answers: answers,
                total: answers.length,
                himself: this.activeStep.transferCondition.id == 'ratio' ? positiveAnswersCount : answersArray
              });
              item.lastAnswers = answers;
              item.fieldAnswers[fieldAnswIndex + 1].answers = [];
              item.fieldAnswers[fieldAnswIndex + 1].total = beforeItem ? beforeItem.total : 0;
              item.fieldAnswers[fieldAnswIndex + 1].himself = beforeItem ? beforeItem.himself : 0;

            } else{

              if(newDay ==  moment(this.minDate).format('YYYY-MM-DD') && fieldAnswIndexNew>=0 ){

                item.fieldAnswers[fieldAnswIndexNew].answers = answers;
                item.lastAnswers = answIndex>=0 ? [...this.activeStep.stimuli[answIndex].lastAnswers, ...answers]: answers;
                item.fieldAnswers[fieldAnswIndexNew].total = beforeItem ? beforeItem.total + answers.length : answers.length;
                item.fieldAnswers[fieldAnswIndexNew].himself = beforeItem ? beforeItem.himself + positiveAnswersCount : positiveAnswersCount;
                item.fieldAnswers.shift();

              } else{
                item.fieldAnswers[fieldAnswIndex].day = newDay;
              }
            }

          }
          item.toNextLevel = this.nextLevel(item);


      });



    },

    isPreviousDateSession(newValue){
      if (!newValue && this.previousDate){
        let oldDay = moment(this.previousDate).format('YYYY-MM-DD');
        let newDay = this.today();

        forEach(this.stimulList, item => {

          let lastAnswersCount = item.attempt;

          if (lastAnswersCount > 0){

            let fieldAnswIndex = findIndex(item.fieldAnswers, field => field.day === oldDay);

            if(fieldAnswIndex >= 0){
              item.fieldAnswers[fieldAnswIndex].day = newDay;
            }

          }
        });
      }
    }


  }
};



// WEBPACK FOOTER //
// ./src/mixins/loadDTTData.js